export default __webpack_public_path__ + "static/Anne-e1585576127940-550d6fcb8ef6c88210021189372f9e73.jpg";